import React, { useState, useEffect } from "react";
import { EditView } from "../components/EditView";

export function Users(props) {
  const [users, setUsers] = useState([]);
  const [admin, setAdmin] = useState(localStorage.getItem("Admin") === "1");
  const [selectedRow, setSelectedRow] = useState(null);

  function handleRowClick(key) {
    setSelectedRow(key);
  }

  function fetchData() {
    setSelectedRow(null);
    fetch("https://inventy.redata.se/inventdb/api-users.php?Command=Select")
      .then((response) => {
        if (!response.ok) {
          throw new Error("Network response was not ok");
        }
        return response.json();
      })
      .then((data) => {
        setUsers(data);
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
  }

  useEffect(() => {
    fetchData();
  }, []);

  return (
    <div style={{ width: "min-content", margin: "auto" }}>
      <table
        style={{
          width: "100%",
          textAlign: "center",
          borderSpacing: 0,
          marginTop: "2vw",
        }}
      >
        <thead>
          <tr>
            <th>Namn</th>
            <th>Epost</th>
            {admin && <th>Admin</th>}
          </tr>
        </thead>
        <tbody>
          {users.map((user) =>
            selectedRow === user.id ? (
              <EditView
                object={user}
                id={user.id}
                type="User"
                refresh={fetchData}
                key={user.id}
              />
            ) : (
              <tr
                key={user.id}
                className="hoverButton"
                onClick={() => handleRowClick(user.id)}
              >
                <td>{user.name}</td>
                <td>{user.email}</td>
                {admin && <td>{user.admin === "1" ? "Ja" : "Nej"}</td>}
              </tr>
            ),
          )}
        </tbody>
      </table>
    </div>
  );
}
